import { render, staticRenderFns } from "./DelegatesList.vue?vue&type=template&id=2ac8cb1e&scoped=true"
import script from "./DelegatesList.vue?vue&type=script&lang=ts"
export * from "./DelegatesList.vue?vue&type=script&lang=ts"
import style0 from "./DelegatesList.vue?vue&type=style&index=0&id=2ac8cb1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac8cb1e",
  null
  
)

export default component.exports